import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a24e90b4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a24e90b4')) {
      api.createRecord('a24e90b4', component.options)
    } else {
      api.reload('a24e90b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a24e90b4&", function () {
      api.rerender('a24e90b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/index.vue"
export default component.exports